var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconRepeatBusiness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 3.53115V6.94918H3.05475M3.05475 6.94918C3.49731 5.82679 4.29054 4.88668 5.3101 4.27619C6.32967 3.6657 7.51795 3.41933 8.68873 3.57569C9.85951 3.73204 10.9466 4.2823 11.7797 5.14021C12.6127 5.99812 13.1446 7.11521 13.2921 8.31639M3.05475 6.94918H6.00008M13.3334 14.4688V11.0508H12.9461M12.9461 11.0508C12.5029 12.1725 11.7094 13.1119 10.69 13.7219C9.67051 14.3318 8.48257 14.5779 7.31215 14.4216C6.14172 14.2653 5.05488 13.7154 4.22177 12.8581C3.38866 12.0007 2.85632 10.8843 2.70808 9.6836M12.9461 11.0508H10.0001",
    stroke: "#374151",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconRepeatBusiness);
export default __webpack_public_path__ + "static/media/common_icon_repeat_business.7618552c8fe5503ee7486b61799da176.svg";
export { ForwardRef as ReactComponent };